import {PanelBody,Panel,RangeControl,SelectControl,ToggleControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls, 
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,	__experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

const imageUpload = (config={}) => {
    if(!config.value){
        config.value = {
            id:0,
            url:false
        };
    }

    if(!config.ratio){
        config.ratio = "1/1";
    }
    return (
        <MediaUploadCheck>
            <MediaUpload
                allowedTypes={ ['image'] }
                value={config.value.id}
                onSelect={(media)=>config.onSelect(media)}
                render={({open}) => (<div className="imageUploadPlaceholder">
                    <img src={config.value.url ? config.value.url : config.placeholder} className={config.className}/>
                    <div className="action">
                        <Button onClick={open} variant="primary">Change Image</Button>
                    </div>
                </div>)}
            />
        </MediaUploadCheck>

    );
};

const imagePanel = (config={
    title:"Image"
}) =>{
    if(!config.value){
        config.value = {
            id:0,
            url:0
        };
    }

    if(!config.ratio){
        config.ratio = "1/1";
    }

    return (<Panel>
        <PanelBody title={config.title} initialOpen={true}>
        {config.value.id == 0 ? (<></>) : (<img src={config.value.url} style={{objectFit:"cover",objectPosition:"center center",maxWidth:"100%",aspectRatio:config.ratio}}/>)}
        {imageUpload(config)}
        </PanelBody>
    </Panel>);
}

export {imagePanel,imageUpload};
